import './PopupSelect'

/**
 * Контрол для выбора значения из справочника DynDict
 *
 * @class
 * @extends UI.Widget.Forms.Control.PopupSelect
 */
UI.Widget.Forms.Control.DynDictSelect = Class(
    UI.Widget.Forms.Control.PopupSelect,
    /** @lends UI.Widget.Forms.Control.DynDictSelect.prototype */
    {
        windowTemplate: "UI/Widget/Forms/Control/DynDictSelect/Window",
        bredcrumbItemTemplate: "UI/Widget/Forms/Control/DynDictSelect/BredcrumbItem",

        masterDictId: null, // ID родительского справочника
        originValue: {},
        items: [], // стэк выбраных элементов
        deep: 0, // уровень текущего открытия попапа
        selectedItems: [],
        breadCrumbsItems: [], //Массив элементов для хлебных крошек

        isMultipleNested: true, // Флаг для проверки явл-ся ли текущий контрол вложенным справочником с возможностью выбора нескольких значений
        preparedRefs: null, //Массив преобразованных значений, который отрисовывается в попапе
        prevItem: null, //Элемент предыдущего уровня, чтобы при переходе во вложенный справочник, можно было выстроить древовидную структуру
        multiOption: null, //Показывает выбранное значение multiple в настройках атрибута
        /**
         * @type {*} Customizer which is invoked to produce the objects of target path
         */
        pathCustomizer: Object,

        initialize: function (parent, $control) {
            this.ParentCall();
            this.itemTemplate = "UI/Widget/Forms/Control/DynDictSelect/Item";
            this.template = "UI/Widget/Forms/Control/DynDictSelect/Control";

            if (this.$control.attr("value")) {
                this.value = JSON.parse(this.$control.attr("value"));
                this.value.refs || (this.value.refs = [])
                this.value.refsvalues = !_.isEmpty(this.value.refsvalues) ? this.value.refsvalues : {};
            } else {
                this.value = {
                    refs: [],
                    refsvalues: {}
                };
            }
            if (this.value.count > 1 && this.$control.attr("multiple")) {
                this.isMultipleNested = true;
            }
        },


        //$selectBtn: null,
        //nullText: "[не выбрано]",

        createElement() {
            this.ParentCall();
            this.masterDictId = this.$control.attr("master");
            this.dictId = this.$control.attr("dict");
            this.multiOption = this.multiple;
        },
        /**
         *
         * @param {Object[]} value
         * @protected
         */
        updateElement(value) {
            const $title = this.$('.ctrl-psel-items');
            let self = this;
            if (_.isEmpty(value)) {
                $title.html(this.nullText);
                return;
            }
            let items;
            items = _.reduce(this.value.refs, (itemReducer, itemValue, itemKey) => {
                var items = [], result = [];
                self.getItemsRec(itemValue, items, result);
                itemReducer = _.concat(itemReducer, result);
                return itemReducer;
            }, []);
            self.preparedRefs = _.flattenDeep(items);
            $title.html(
                _.map(
                    items || [],
                    item => UI.Template.render(this.itemTemplate, {
                        control: this,
                        item,
                        viewOnly: this.viewOnly
                    })
                ).join('')
            );

            this.setMode(this.mode)
        },
        //Превращает дерево элементов в массив
        getItemsRec: function (refs, item, result) {
            let elementaryItem = {};
            elementaryItem[this.valueKey] = refs.id;
            elementaryItem[this.titleKey] = this.value.refsvalues[refs.id];
            item.push(elementaryItem);
            if (refs.refs == null || refs.refs.length === 0) {
                let itemClone = _.cloneDeep(item);
                result.push(itemClone);
                item.pop();
                return;
            }
            var self = this;
            _.forEach(refs.refs, function (ref) {
                self.getItemsRec(ref, item, result);
            });
            item.pop();
        },

        updateBredcrumb() {
            if (this.multiple && !this.isMultipleNested) return this;
            let $bredcrumb = this.popup.$el.find('.ctrl-psel-bredcrumb');

            $bredcrumb.html(
                _.map(
                    this.breadCrumbsItems,
                    (item, k) => UI.Template.render(this.bredcrumbItemTemplate, {
                        widget: this, item,
                        deep: k
                    })
                ).join(' ')
            );
            UI.Element.initEvent("click", "on-click", $bredcrumb, this);
        },

        onBredcrumbItemClick(el, e) {
            this.deep = $(el).data('deep');
            //Не понял почему onBredcrumbsItemClick вызывается n раз, где n - глубина кликнутой хлебной крошки
            if(this.deep < this.breadCrumbsItems.length) {
                this.prevItem = this.breadCrumbsItems[this.deep - 1];
                this.breadCrumbsItems.splice(this.deep , this.breadCrumbsItems.length);
                this.deep--;
                this.setValue(this.value.refs, true);

                this.updateBredcrumb();
                this.updateGrid();
                this.updateMasterTags();
            }
        },

        getDeep() {
            if (!this.multiple) {
                if (this.items.length && this.items[this.items.length - 1].options && this.items[this.items.length - 1].options.dictid) {
                    return this.items.length;
                } else
                    return this.items.length ? this.items.length - 1 : 0;
            }
            return 0;
        },

        createPopup: async function () {
            let parentCall = this.ParentCall;
            let self = this;


            this.breadCrumbsItems = [this.value];


            this.prevItem = this.value;
            this.$loader.show();
            if (this.isMultipleNested) {
                this.selectedItems = [];
                this.items = await Promise.all(_.map(_.uniqBy(this.preparedRefs, 'id'), async function (refid) {
                    return (await self.ds.get({id: refid[self.valueKey]})).item;
                }));
            } else {
                this.items = await Promise.all(_.map(this.value.refs, async function (refid) {
                    return (await self.ds.get({id: refid})).item;
                }));
            }
            this.$loader.hide();
            this.deep = this.getDeep();
            parentCall.call(this);

            if (this.isMultipleNested) {
                // Обработка нажатия на кнопку "Завершить" выбор
                this.popup.content.find(".ctrl-psel-finish").on("click", function () {
                    self.destroyPopup();
                });
                //Обработка события удаления всех значений контрола
                this.popup.content.find(".ctrl-psel-remove").on("click", function () {
                    self.value.refsvalues = {};
                    self.value.refs = {};
                    self.value.count = 0;
                    self.setValue(self.value.refs, true);
                    self.destroyPopup();
                });
                //Обработка исключения элемента из списка
                this.grid.on("deselectItem", function (item) {
                    // Нет повести печальнее на свете, чем повесть о закомменченом коде, над которым ты просидел 2 недели
                    if(item) {
                        self.unselectItem(item, self.value.refs, false, self.value);
                        self.setValue(self.value.refs, true);
                    }
                })


            }
            this.updateBredcrumb();
        },
        /**
         * @return {UI.Widget.DataGridView}
         * @protected
         */
        createGrid(options) {
            return this.ParentCall().on('update', () => {
                _.forEach(this.getValue(), (value) => {
                    let item = {};
                    item[this.valueKey] = value;
                    this.grid.selectItem(item, this.multiple ? 'multiple' : undefined, {'deselect': false});
                });
            });
        },
        updateGrid() {
            this.grid.filter = this._getFilter();
            this.grid.reset()
        },
        _getFilter() {
            let filter = {
                tags: []
            };
            Object.assign(filter, this.filter);

            const masterTags = UI.Widget.Forms.Control.DynDictSelect.masterTags[this.masterDictId];
            if (this.masterDictId && masterTags)
                filter.tags.push(masterTags);

            if (this.deep) {
                if (this.prevItem.id) {
                    filter.tags.push(this.prevItem.id);
                }
                if (this.prevItem.options && this.prevItem.options.dictid) {
                    filter.dictid = this.prevItem.options.dictid;
                }
            }
            return filter;
        },

        /**
         * @protected
         */
        reset() {
            this.ParentCall();
            this.value.refsvalues = {};
            this.value.refs = [];
            this.updateMasterTags();
        },

        setValue: function (value, update) {
            this.ParentCall();
            let target = this.parseTarget();
            if (target && this.pathCustomizer)
                _.setWith(this.parent, target + 'Value', this.value.refsvalues, this.pathCustomizer);
            _.setWith(this.parent, target.replace("refs", "count"), this.value.count);
        },
        /**
         * @param {{ item: Object }} evt
         * @protected
         */
        onSelectItem(evt) {
            let options = null;
            if(!this.multiple) {
                this.prevItem.refs || (this.prevItem.refs = []);
                if((this.prevItem.refs.length && this.prevItem.refs[0].id != evt.item.id) || !this.prevItem.refs.length) {
                    this.prevItem.refs = [evt.item];
                    this.value.refsvalues[evt.item[this.valueKey]] = evt.item[this.titleKey];
                    this.grid && this.grid.selectItem(evt.item, this.multiple ? 'multiple' : undefined);
                }
            } else {
                this.pushItem(evt.item, options);
                if (this.maxq && this.value.refs.length >= this.maxq) {
                    alert("Для данного атрибута невозможно выбрать не более " + this.maxq + " значений.");
                    return;
                }
            }
            this.setValue(this.value.refs, true);
            this.updateMasterTags();
        },
        pushItem(item, options) {
            this.prevItem.refs || (this.prevItem.refs = []);
            let index = _.findIndex(this.prevItem.refs, {id: item.id});
            let returnedItem = null;
            if (~index) {
                returnedItem = this.prevItem.refs[index]
            } else {
                this.prevItem.refs.push(item);
                this.value.count++;
                returnedItem = item;
            }
            this.value.refsvalues[item[this.valueKey]] = item[this.titleKey];
            this.items.push(item);
            this.setValue(this.value.refs, true);
            this.grid && this.grid.selectItem(item, this.multiple ? 'multiple' : undefined, options);
            return returnedItem;
        },
        /**
         *
         * @param unSelectableItem
         * @param refs
         * @param isFinished флаг, уведомляющий о том, что элемент был удален
         */
        unselectItem(unSelectableItem, refs, isFinished, parent) {
            let self = this;
            if(isFinished){
                return;
            }
            _.forEach(refs, function (item, index) {
                if (item.id === unSelectableItem.id) {
                    refs[index] = null;
                    parent.refs = _.compact(refs);
                    isFinished = true;
                    return false;
                } else {
                    self.unselectItem(unSelectableItem, item.refs, isFinished, item);
                }
            })
        },

        onNextItemSelect(evt) {
            var self = this;
            if(!this.multiple) {
                evt.item.refs = [];
                this.prevItem.refs = [evt.item];
                this.value.refsvalues[evt.item.id] = evt.item.value;
                this.prevItem = evt.item;
                this.setValue(this.value.refs, true);
            } else {
                this.prevItem = this.pushItem(evt.item, {'deselect': false});
            }

            if (evt.item.options && evt.item.options.dictid) {
                if(this.prevItem.value) {
                    this.breadCrumbsItems.push(this.prevItem);
                } else {
                    this.breadCrumbsItems.push(this.value);
                }
                this.deep++;
                this.updateBredcrumb();
                this.updateGrid();
                this.grid.on("update", function () {
                    _.forEach(self.prevItem.refs, function (item) {
                        self.grid && self.grid.selectItem(item, self.multiple ? "multiple" : undefined, {'deselect': false});
                    })
                })
            }

        },

        /**
         * @protected
         */
        updateMasterTags() {
            const value = this.getValue() || [];

            if (_.isEmpty(value)) {
                UI.Widget.Forms.Control.DynDictSelect.masterTags[ this.dictId ] = null;
            } else {
                UI.Widget.Forms.Control.DynDictSelect.masterTags[ this.dictId ] = value;
            }
        },
        /**
         * @param {Event} evt
         * @protected
         */
        onRemoveClick(evt) {
            const $btn = $(evt.target).parent();
            const path = $btn.data('path').toString().split("/");
            let removableItem = this.getRemovableItem(path);
            if(removableItem) {
                this.unselectItem(removableItem, this.value.refs, false, this.value);
                this.setValue(this.value.refs, true);
            }
        },

        //Возвращает удаляемый элемент
        //Ищет родительский элемент в дереве, у которого все дочерние элементы имеют не более чем 1 дочерний элемент
        //Необходимо для удаления строки из контрола
        getRemovableItem(path) {
            let deep = path.length,
                iterationDeep = 0;
            let item = this.value,
                iterationsCount = 0,
                parents = [];
            while (iterationDeep !== deep) {
                _.forEach(item.refs, function (element) {
                    if(element.id === +path[iterationDeep]) {
                        parents.push(item);
                        item = element;
                        iterationDeep++;
                        iterationsCount = 0;

                        return false;
                    } else {
                        iterationsCount++;
                    }
                });
                //Защита от зацикливания
                if(iterationsCount > this.value.count) {
                    return null
                }
            }
            let i = parents.length - 1;
            while(parents[i].refs.length <= 1 && i > 0) {
                item = parents[i];
                i--;
            }
            return item;
        },

        editMode() {
            this.ParentCall()
            this.$('.breadcrumb-item, .remove').show()
        },
        viewMode() {
            this.ParentCall()
            this.$('.breadcrumb-item, .remove').hide()
        },

        setMultiple(value) {
            this.multiple = value;
        }
    }
);

UI.Widget.Forms.Control.DynDictSelect.masterTags = {};
